import { ENV_MODE, initAccessibe } from '@support/utils';
import { REGION_MODE } from '@support/utils';
// 海外添加无障碍插件
export default () => {
  if (process.client) {
    REGION_MODE == 'us' && ENV_MODE == 'prod' && initAccessibe();
  }
};
